import { Pipe, PipeTransform } from '@angular/core'
import { getAutomationEventName } from '@tokeet-frontend/automations'

@Pipe({ name: 'eventName' })
export class AutomationEventNamePipe implements PipeTransform {
  transform(value: string) {
    return getAutomationEventName(value) || ''
  }
}
